import { __decorate } from "tslib";
import { singleton } from 'mana-syringe';

var DisplayObjectPool =
/** @class */
function () {
  function DisplayObjectPool() {
    this.pool = {};
  }

  DisplayObjectPool.prototype.getByEntity = function (entity) {
    return this.pool[entity];
  };

  DisplayObjectPool.prototype.add = function (entity, groupOrShape) {
    this.pool[entity] = groupOrShape;
  };

  DisplayObjectPool.prototype.remove = function (entity) {
    delete this.pool[entity];
  };

  DisplayObjectPool = __decorate([singleton()], DisplayObjectPool);
  return DisplayObjectPool;
}();

export { DisplayObjectPool };